<mat-label class="subHeading">Incentive %<span *ngIf="isRequired" class="star">*</span></mat-label>

<input class="mt-2" formControlName="incentive" [maxlength]="9" type="text" placeholder="Enter payout percent" appNumberOnly appPercentOnly>
